import React from 'react';
import Formsy from 'formsy-react';
import SVGTrash from '../../svg/Trash.js';
import MoneyInput from '../form/MoneyInput';
import Select from '../form/Select';
import { maskMoney, maskDateTime } from '../../masks';
import { Link } from 'react-router-dom';
import { adminChefName } from '../../masks';
import { CHEF_ROLES } from '../../const';
import { getOverrideClass } from '../../helpers/autofillOverride';
import { isOccasion } from '../../helpers/serviceUtil';

class ServiceStaff extends React.Component {
  roleOptions = [
    { value: CHEF_ROLES['CHEF'], label: CHEF_ROLES['CHEF'] },
    { value: CHEF_ROLES['SOUS_CHEF'], label: CHEF_ROLES['SOUS_CHEF'] },
    { value: CHEF_ROLES['WAITER'], label: CHEF_ROLES['WAITER'] },
    { value: CHEF_ROLES['BARTENDER'], label: CHEF_ROLES['BARTENDER'] },
  ];

  getStatusOptions(staff) {
    const options = [
      { value: 'accepted', label: 'Confirmed' },
      { value: 'pending', label: 'Pending' },
      { value: 'rejected', label: 'Declined' },
    ];
    if (
      staff &&
      [CHEF_ROLES['WAITER'], CHEF_ROLES['BARTENDER']].includes(staff.role)
    ) {
      options.unshift({ value: 'waiting_to_order', label: 'Waiting To Order' });
    }
    return options;
  }

  addPlaceholder(role, count, placeholders) {
    for (let i = 0; i < count; i++) {
      placeholders.push({
        chef: { phone_number: '-' },
        role: role,
        rate: '0',
        status: 'pending',
      });
    }
  }

  getStaffPlaceholders() {
    let { invited_chefs: staff } = this.props.service;
    const { staffRequirements } = this.props;

    let placeholderStaff = [];
    let surplusStaffIds = new Set();
    staff = staff || [];

    if (staffRequirements) {
      // count how many of each staff type are currently selected

      let chefCount = staffRequirements.requiredChefs;
      let sousChefCount = staffRequirements.requiredSousChefs;
      let waiterBartenderCount = staffRequirements.requiredBartenders;

      for (let s of staff) {
        switch (s.role) {
          case CHEF_ROLES['CHEF']:
            chefCount--;
            if (chefCount < 0) {
              surplusStaffIds.add(s.chef.id)
            }
            break;
          case CHEF_ROLES['SOUS_CHEF']:
            sousChefCount--;
            if (sousChefCount < 0) {
              surplusStaffIds.add(s.chef.id)
            }
            break;
          case CHEF_ROLES['WAITER']:
          case CHEF_ROLES['BARTENDER']:
            waiterBartenderCount--;
            if (waiterBartenderCount < 0) {
              surplusStaffIds.add(s.chef.id)
            }
            break;
          default:
        }
      }

      this.addPlaceholder(
        CHEF_ROLES['CHEF'],
        chefCount,
        placeholderStaff
      );
      this.addPlaceholder(
        CHEF_ROLES['SOUS_CHEF'],
        sousChefCount,
        placeholderStaff
      );
      this.addPlaceholder(
        CHEF_ROLES['WAITER'],
        waiterBartenderCount,
        placeholderStaff
      );
    }

    return [placeholderStaff, surplusStaffIds];
  }

  render() {
    const [staffPlaceholder, surplusStaffIds] = this.getStaffPlaceholders();
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Staff</h3>
          </div>
          <div className="cms__bar-right">
            {this.renderEditButton(staffPlaceholder)}
            {this.renderSaveButton()}
          </div>
        </div>
        {this.props.staffRequirements && this.renderStaffRequirements()}
        {this.renderBody(staffPlaceholder, surplusStaffIds)}
      </div>
    );
  }

  renderStaffRequirements() {
    return (
      <div className="row">
        <div className="p p--pad-bot p--pad-left">
          <div>
            Required Chefs: {this.props.staffRequirements['requiredChefs']}
          </div>
          <div>
            Required Sous Chefs:{' '}
            {this.props.staffRequirements['requiredSousChefs']}
          </div>
          <div>
            Required Waiters / Bartenders:{' '}
            {this.props.staffRequirements['requiredBartenders']}
          </div>
        </div>
      </div>
    );
  }

  renderBody(placeholderStaff, surplusStaffIds) {
    const { invited_chefs: staff, start_time, end_time } = this.props.service;
    if (start_time && end_time)
      return (
        <div className="cms__section-body">
          {this.renderStaffHeader(placeholderStaff)}
          {staff
            ? staff.map((staff, i) => {
                let isSurplus = surplusStaffIds.has(staff.chef.id)
                return this.props.isEdit
                  ? this.renderStaffEdit(staff, i, false, isSurplus)
                  : this.renderStaffView(staff, i, false, isSurplus)
            })
            : ''}
          {placeholderStaff
            ? placeholderStaff.map((staff, i) =>
                this.props.isEdit
                  ? this.renderStaffEdit(staff, i, true)
                  : this.renderStaffView(staff, i, true)
              )
            : ''}
          {this.renderAddButton()}
        </div>
      );
    else
      return (
        <p className="p">Select a date, start and end time to assign staff.</p>
      );
  }

  renderEditButton = (placeholders) => {
    const { invited_chefs: staff = [] } = this.props.service;

    if (!this.props.isEdit && (staff.length || placeholders.length))
      return (
        <span className="a--blue" onClick={this.openEdit}>
          Edit
        </span>
      );
  };

  renderSaveButton = () => {
    const { invited_chefs: staff = [] } = this.props.service;
    if (this.props.isEdit && staff.length)
      return (
        <span className="a--blue" onClick={this.closeEdit}>
          Preview
        </span>
      );
  };

  renderAddButton = () => {
    const { invited_chefs: staff = [] } = this.props.service;
    if (this.props.isEdit || !staff.length)
      return (
        <div
          className="btn btn--white btn--full-width"
          onClick={this.props.openAddStaffModal}
        >
          + Add Staff
        </div>
      );
  };

  renderStaffHeader = (placeholders) => {
    const { invited_chefs: staff = [] } = this.props.service;
    const { showTips } = this.props;
    if (staff.length || placeholders.length)
      return (
        <div className="p row row--space-between row--pad row--border-bottom">
          <div className="row__item row__item--fifth p--bold">Name</div>
          <div className="row__item row__item--sixth p--bold">Phone Number</div>
          <div
            className={`row__item row__item${
              showTips ? '--sixth' : '--fifth'
            } p--bold`}
          >
            Role
          </div>
          <div className="row__item row__item--sixth p--bold">Rate</div>
          {showTips && (
            <div className="row__item row__item--tenth p--bold">Tip</div>
          )}
          <div
            className={`row__item row__item${
              showTips ? '--tenth' : '--fifth'
            } p--bold`}
          >
            Status
          </div>
          <div className="row__item row__item--tenth p--bold">
            {!this.props.isEdit ? 'Send Opportunity' : ''}
          </div>
        </div>
      );
  };

  renderStaffView = (staff, i, isPlaceholder, isSurplus) => {
    const { showTips, showOverrides } = this.props;
    return (
      <div key={i} className={`p row row--space-between row--pad ${isSurplus && 'row--red'}`}>
        <div className="row__item row__item--fifth">
          {isPlaceholder ? (
            'Please Select Staff'
          ) : (
            <Link
              className="a--black"
              target="_blank"
              to={`/admin/chef/${staff.chef.id}`}
            >
              {adminChefName(staff.chef)}
            </Link>
          )}
        </div>
        <div className="row__item row__item--sixth">
          {staff.chef.phone_number || ''}
        </div>
        <div
          className={`row__item row__item${showTips ? '--sixth' : '--fifth'}`}
        >
          {staff.role || ''}
        </div>
        <div
          className={`row__item row__item--sixth ${showOverrides ? getOverrideClass(
            this.props.service,
            `invited_chef.${staff.chef.id}.rate`
          ) : ''}`}
        >
          {maskMoney(this.getStaffRate(staff))}
        </div>
        {showTips && (
          <div
            className={`row__item row__item--tenth ${showOverrides ? getOverrideClass(
              this.props.service,
              `invited_chef.${staff.chef.id}.tip_cents`
            ): ''}`}
          >
            {maskMoney(this.getStaffTip(staff))}
          </div>
        )}
        <div
          className={`row__item row__item${showTips ? '--tenth' : '--fifth'}`}
        >
          {this.renderStatus(staff)}
        </div>
        <div className="row__item row__item--tenth">
          {staff.invite_last_sent
            ? `Last sent: ${maskDateTime(staff.invite_last_sent)}`
            : ''}
          {!isPlaceholder && (
            <p
              className="a--blue"
              onClick={() => this.props.openSendDetailsModal(staff)}
            >
              {staff.invite_last_sent ? ' Resend' : 'Send'}
            </p>
          )}
        </div>
      </div>
    );
  };

  /*
    // TODO - Open Modal
          {staff.invite_last_sent ? `Last sent: ${maskDateTime(staff.invite_last_sent)}` : ''}
          <p className="a--blue" onClick={() => this.props.sendStaffMail(staff)}>
            {staff.invite_last_sent ? " Resend" : "Send"}
          </p>
   */

  openAddStaffWithDefaultRole = (defaultRole) => {
    this.props.updateService({}, { defaultRole });
    this.props.openAddStaffModal();
  };

  renderStaffEdit = (staff, i, isPlaceholder, isSurplus) => {
    const { showTips } = this.props;
    return (
      <div key={i} className={`p row row--space-between row--bordered ${isSurplus && 'row--red'} form`}>
        <div className="row--bordered__item row__item--fifth">
          {isPlaceholder ? (
            <div
              className="btn btn--white btn--full-width"
              onClick={() => this.openAddStaffWithDefaultRole(staff.role)}
            >
              + Add Staff
            </div>
          ) : (
            adminChefName(staff.chef)
          )}
        </div>
        <div className="row--bordered__item row__item--sixth">
          {staff.chef.phone_number || ''}
        </div>
        <div
          className={`row--bordered__item row__item${
            showTips ? '--sixth' : '--fifth'
          } group`}
        >
          {isPlaceholder ? (
            staff.role
          ) : (
            <Formsy>
              <Select
                name="role"
                value={staff.role || ''}
                options={this.roleOptions}
                onChange={(e) => this.handleStaffRoleChange(staff, e)}
                disabled={isPlaceholder}
              />
            </Formsy>
          )}
        </div>
        <div className="row--bordered__item row__item--sixth">
          <MoneyInput
            className="simple-input"
            type="text"
            name="rate"
            valueCents={this.getStaffRate(staff)}
            onChange={(cents) => this.handleStaffRateChange(staff, cents)}
            disabled={!!isPlaceholder}
          />
        </div>
        {showTips && (
          <div className="row--bordered__item row__item--tenth">
            <MoneyInput
              className="simple-input"
              type="text"
              name="tip_cents"
              valueCents={this.getStaffTip(staff)}
              onChange={(cents) => this.handleStaffTipChange(staff, cents)}
              disabled={!!isPlaceholder}
            />
          </div>
        )}
        <div
          className={`row--bordered__item row__item${
            showTips ? '--tenth' : '--fifth'
          }`}
        >
          {isPlaceholder ? (
            this.renderStatus(staff)
          ) : (
            <Formsy>
              <Select
                name="status"
                value={staff.status || ''}
                options={this.getStatusOptions(staff)}
                onChange={(e) => this.handleStaffStatusChange(staff, e)}
              />
            </Formsy>
          )}
        </div>
        <div className="row--bordered__item row__item--tenth">
          {!isPlaceholder && (
            <span
              className="btn-icon btn-icon--trash"
              onClick={() => this.deleteStaff(i)}
            >
              <SVGTrash />
            </span>
          )}
        </div>
      </div>
    );
  };

  renderStatus = (staff) => {
    const option = this.getStatusOptions(staff).find(
      (opt) => opt.value === staff.status
    );
    return option ? option.label : null;
  };

  openEdit = () => {
    this.props.updateService({}, { isStaffEdit: true });
  };

  closeEdit = () => {
    this.props.updateService({}, { isStaffEdit: false });
  };

  deleteStaff = (index) => {
    const { invited_chefs: staff = [] } = this.props.service;
    const invited_chefs = [
      ...staff.slice(0, index),
      ...staff.slice(index + 1, staff.length),
    ];
    this.props.updateService({ invited_chefs });
  };

  getStaffRate = (staff) => {
    return staff.rate || staff.rate === '' ? staff.rate : staff.chef.tier;
  };

  getStaffTip = (staff) => {
    return staff.tip_cents || '0';
  };

  handleStaffRateChange = (staff, cents) => {
    if (isOccasion(this.props.service)) {
      const override_fields = {
        [`invited_chef.${staff.chef.id}.rate`]: true,
        ...this.props.service.override_fields,
      };
      this.props.updateService({ override_fields });
    }

    const invited_chefs = this.props.service.invited_chefs.map((invite) =>
      invite.chef.id === staff.chef.id ? { ...invite, rate: cents } : invite
    );
    this.props.updateService({ invited_chefs });
  };

  handleStaffTipChange = (staff, cents) => {
    if (isOccasion(this.props.service)) {
      const override_fields = {
        [`invited_chef.${staff.chef.id}.tip_cents`]: true,
        ...this.props.service.override_fields,
      };
      this.props.updateService({ override_fields });
    }

    const invited_chefs = this.props.service.invited_chefs.map((invite) =>
      invite.chef.id === staff.chef.id
        ? { ...invite, tip_cents: cents }
        : invite
    );
    this.props.updateService({ invited_chefs });
  };

  handleStaffChange = (staff, e) => {
    const invited_chefs = [...(this.props.service.invited_chefs || [])];
    const index = invited_chefs.findIndex(
      (invited_chef) => invited_chef.id === staff.id
    );
    let value = e.target.value;
    staff[e.target.name] = value;
    invited_chefs[index] = staff;
    this.props.updateService({ invited_chefs });
  };

  handleStaffRoleChange = (staff, option) => {
    const invited_chefs = this.props.service.invited_chefs.map((invite) =>
      invite.chef.id === staff.chef.id
        ? {
            ...invite,
            status: this.getStaffStatus(option, staff),
            role: option ? option.value : null,
          }
        : invite
    );
    this.props.updateService({ invited_chefs });
  };

  // since some roles don't share statuses, we may want to auto-update a invite's status if the role changes
  getStaffStatus = (option, staff) => {
    if (!staff.invite_last_sent && option) {
      switch (option.value) {
        case CHEF_ROLES['BARTENDER']:
        case CHEF_ROLES['WAITER']:
          if (staff.status === 'pending') {
            return 'waiting_to_order';
          }
          break;
        case CHEF_ROLES['CHEF']:
        case CHEF_ROLES['SOUS_CHEF']:
          if (staff.status === 'waiting_to_order') {
            return 'pending';
          }
          break;
        default:
      }
    }
    return staff.status;
  };

  handleStaffStatusChange = (staff, option) => {
    const invited_chefs = this.props.service.invited_chefs.map((invite) =>
      invite.chef.id === staff.chef.id
        ? { ...invite, status: option ? option.value : null }
        : invite
    );
    this.props.updateService({ invited_chefs });
  };
}

export default ServiceStaff;



// WEBPACK FOOTER //
// ./src/components/service/ServiceStaff.js